import { compare, now, op_Subtraction, parse } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { totalDays } from "./fable_modules/fable-library-js.4.24.0/TimeSpan.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { uncurry2, int32ToString, comparePrimitives, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { cons, empty as empty_1, singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { fold, empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { DialogActions, DialogContent, DialogTitle, Dialog, InputAdornment, IconButton, TableHead, TextField, Checkbox, Radio, FormControlLabel, RadioGroup, FormControl, Button, Typography, ListItemText, ListItem, List, Paper, TableBody, Table, TableRow, TableCell } from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { loadingIndicatorSmall, wrapTooltip } from "./ViewHelpers.js";
import { isNullOrWhiteSpace, join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { splitInto, sortBy, map } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { Styles_textOverflow } from "./Design.js";
import { unwrap, toArray, some, map as map_1, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { fromDateTime, parse as parse_1 } from "./fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { Tickets_toLocalizedWarrantyType, toDateOnlyStr } from "./Locale.js";
import ArrowRight from "@mui/icons-material/ArrowRight";
import ArrowLeft from "@mui/icons-material/ArrowLeft";
import Search from "@mui/icons-material/Search";
import { parse as parse_2 } from "./fable_modules/fable-library-js.4.24.0/Int32.js";
import { Tickets_TicketType, Tickets_TicketType__get_Id, Orders_OrderStatus__ToString_12C6553D, Tickets_WarrantyType_All, Tickets_WarrantyType__get_Identifier } from "./Shared/Shared.js";
import { toString } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import Delete from "@mui/icons-material/Delete";
import Add from "@mui/icons-material/Add";
import { ctx as ctx_1 } from "./Context.js";
import { API_Orders_Order } from "./Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Tickets_WarrantyPart, Order_$reflection } from "./Shared/ApiDataTypes.js";
import { mapFetchError, testRedirect, extraCoders } from "./Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString as toString_1 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { obj_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import PriorityHigh from "@mui/icons-material/PriorityHigh";
import Warning from "@mui/icons-material/Warning";
import { debounce as debounce_1 } from "./Utils.js";

/**
 * Converts a utc-formatted string into a date and calculates number of days difference from now
 */
export function utcStringToLocalDaySpan(dt, locale) {
    try {
        const date = parse(dt);
        const matchValue = totalDays(op_Subtraction(now(), date));
        return (matchValue < 1) ? locale.t("Ticket.Duration.Today") : ((matchValue < 2) ? (`1 ${locale.t("Ticket.Duration.Day")}`) : (`${~~matchValue} ${locale.t("Ticket.Duration.Days")}`));
    }
    catch (matchValue_1) {
        return "";
    }
}

/**
 * Converts minutes into number of hours and leftover minutes
 */
export function minutesToHoursAndMinutes(x) {
    return [~~(x / 60), x % 60];
}

export function sectionHeader(title) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        backgroundColor: "hsl(207.3, 30.8%, 21%)",
        color: "#FFFFFF",
        padding: ((((((10 + "px ") + 24) + "px ") + 8) + "px ") + 16) + "px",
    }], (elems = [createElement("span", {
        style: {
            fontWeight: 500,
            fontSize: 0.875 + "rem",
            letterSpacing: 0.01071 + "em",
        },
        children: title,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function sectionHeaderWith(title, actions) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        color: "#FFFFFF",
        backgroundColor: "hsl(207.3, 30.8%, 21%)",
        padding: ((((((10 + "px ") + 24) + "px ") + 8) + "px ") + 16) + "px",
    }], (elems = toList(delay(() => append(singleton(createElement("span", {
        style: {
            fontWeight: 500,
            fontSize: 0.875 + "rem",
            letterSpacing: 0.01071 + "em",
            flexGrow: 1,
        },
        children: title,
    })), delay(() => actions)))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function thHeader(title) {
    return MuiHelpers_createElement(TableCell, [["style", {
        backgroundColor: "hsl(207.3, 30.8%, 21%)",
        color: "#FFFFFF",
        maxWidth: 180,
        width: 180,
    }], ["variant", "head"], ["children", title]]);
}

export function tdHeaderTitled(title) {
    return MuiHelpers_createElement(TableCell, [["variant", "body"], ["children", title]]);
}

export function tdHeader(children) {
    return MuiHelpers_createElement(TableCell, [["variant", "body"], ["children", reactApi.Children.toArray(Array.from(children))]]);
}

export function trHeader(title, content) {
    const children = ofArray([thHeader(title), tdHeaderTitled(content)]);
    return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]);
}

export function trEmptyHeader() {
    let elements;
    const children = ofArray([MuiHelpers_createElement(TableCell, [["style", {
        backgroundColor: "hsl(207.3, 30.8%, 21%)",
        color: "hsl(207.3, 30.8%, 21%)",
        color: "#FFFFFF",
        maxWidth: 180,
        width: 180,
    }], ["variant", "head"], (elements = [createElement("span", {
        style: {
            color: "hsl(207.3, 30.8%, 21%)",
            userSelect: "none",
        },
        children: "N/A",
    })], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(TableCell, [["style", {
        backgroundColor: "#ddd",
    }]])]);
    return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]);
}

export function trHeader$0027(title, children) {
    const children_1 = ofArray([thHeader(title), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray(Array.from(children))]])]);
    return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_1))]]);
}

export function tdVisibility(locale, isBig, isHidden) {
    return MuiHelpers_createElement(TableCell, toList(delay(() => append(!isBig ? singleton(["style", {
        maxWidth: 25,
        width: 25,
    }]) : empty(), delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["variant", "body"]), delay(() => {
        let elements, elems, child, props_1, props_3;
        return singleton((elements = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 3 + "px ",
        }], (elems = [(child = (isHidden ? ((props_1 = {
            style: {
                color: "#FF8C00",
            },
        }, react.createElement(VisibilityOff, props_1))) : ((props_3 = {
            style: {
                color: "hsl(207.3, 30.8%, 21%)",
            },
        }, react.createElement(Visibility, props_3)))), wrapTooltip(isHidden ? locale.t("TicketList.IsHidden") : locale.t("TicketList.NotHidden"), child))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elements))]));
    })))))))));
}

export const combineText = (arg) => join(", ", map((m) => m.Name, arg));

export function tdMachines(machines) {
    let elements;
    const combinedText = combineText(machines);
    return MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], (elements = [createElement("div", {
        style: createObj(toList(delay(() => append(Styles_textOverflow, delay(() => singleton(["maxWidth", 25 + "ch"])))))),
        title: combinedText,
        children: combinedText,
    })], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

/**
 * Helper function for rendering the skeleton of the "header" section of a ticket view
 */
export function headerHolder(topLeftRows, topRightRows) {
    let elems_7, elems_6, elems_2, elements_1, elems_5, elements_3;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 1 + "vw",
    }], (elems_7 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        gap: 1 + "vw",
    }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexGrow: 1,
    }], (elems_2 = [MuiHelpers_createElement(Table, [["size", "small"], (elements_1 = [MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(topLeftRows))]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexGrow: 1,
    }], (elems_5 = [MuiHelpers_createElement(Table, [["size", "small"], (elements_3 = [MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(topRightRows))]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

/**
 * Ticket view component for handling machine selection for a ticket. Displays list of selected and not selected machines.
 */
export function machineSelection(locale, dateFnsLocale, selectedCustomer, selected, onSelect, onSelectAll, onUnselectAll, onUnselect) {
    let elems_8, elems_7;
    const machineSelection_1 = (machines, onClick) => {
        let elements_2, elements_1;
        return MuiHelpers_createElement(Paper, [["elevation", 1], ["style", {
            minWidth: 300,
            height: 100 + "%",
            minHeight: 300,
        }], (elements_2 = [MuiHelpers_createElement(List, [["dense", true], (elements_1 = [map((m_1) => {
            let elements;
            return MuiHelpers_createElement(ListItem, [["key", m_1.Id], ["button", true], ["dense", true], ["onClick", (_arg) => {
                onClick(m_1.Id);
            }], (elements = [MuiHelpers_createElement(ListItemText, [["primary", m_1.Name], ["secondary", defaultArg(map_1((weStr) => {
                try {
                    const we = parse_1(weStr);
                    const today = fromDateTime(now());
                    const expiryStr = toDateOnlyStr(dateFnsLocale, we);
                    return (compare(we, today) < 0) ? (`${locale.t("MachineView.WarrantyExpired")} ${expiryStr}`) : (`${locale.t("MachineView.WarrantyExpires")} ${expiryStr}`);
                }
                catch (e) {
                    console.error(some("Could not parse warranty expiry date:"), e.message);
                    return "";
                }
            }, m_1.WarrantyExpiry), "")]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
        }, sortBy((m) => m.Name, machines, {
            Compare: comparePrimitives,
        }))], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_8 = [sectionHeader(locale.t("Machines")), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: 20 + "px ",
        padding: 20,
    }], (elems_7 = toList(delay(() => {
        let elems_3;
        if (selectedCustomer != null) {
            let machines_1;
            const array_3 = selectedCustomer.Machines;
            machines_1 = array_3.filter((m_2) => !selected.some((sm) => (sm.Id === m_2.Id)));
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            }], (elems_3 = [MuiHelpers_createElement(Typography, [["children", locale.t("TicketForm.Available")]]), machineSelection_1(machines_1, onSelect)], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_5, elems_4, props_6, props_9;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }], (elems_5 = [createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 10 + "px ",
                }], (elems_4 = [MuiHelpers_createElement(Button, [["variant", "outlined"], ["size", "small"], ["color", "primary"], ["children", (props_6 = {}, react.createElement(ArrowRight, props_6))], ["onClick", (_arg_1) => {
                    onSelectAll();
                }], ["aria-label", "Select all"]]), MuiHelpers_createElement(Button, [["variant", "outlined"], ["size", "small"], ["color", "primary"], ["children", (props_9 = {}, react.createElement(ArrowLeft, props_9))], ["onClick", (_arg_2) => {
                    onUnselectAll();
                }], ["aria-label", "Deselect all"]])], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                    let elems_6;
                    return singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                    }], (elems_6 = [MuiHelpers_createElement(Typography, [["children", locale.t("TicketForm.Selected")]]), machineSelection_1(selected, onUnselect)], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                }));
            }));
        }
        else {
            return singleton(MuiHelpers_createElement(Typography, [["children", locale.t("TicketForm.SelectCustomer")]]));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

/**
 * Displays ticket responsible. Admins can edit this selection.
 */
export function ticketResponsible(locale, responsible, canAdminEdit, onToggleForm) {
    let elems_1;
    const children_1 = ofArray([thHeader(locale.t("Ticket.Responsible")), tdHeader([createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => append(singleton(createElement("span", {
        children: [fold((_arg, r) => r, locale.t("TicketForm.WillBeFilled"), toArray(responsible))],
    })), delay(() => {
        let child_1, elems, props_2;
        return canAdminEdit ? singleton((child_1 = createElement("div", createObj(ofArray([["onClick", (_arg_1) => {
            onToggleForm();
        }], ["style", {
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
        }], (elems = [(props_2 = {}, react.createElement(Search, props_2))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), wrapTooltip(locale.t("Edit"), child_1))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))])]);
    return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_1))]]);
}

export function warrantyType(locale, current, warrantyText, onSelect, onWarrantyText) {
    let elems_5, elems_3, elements_1, elems_4, children;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_5 = [sectionHeader(locale.t("Ticket.WarrantyType.WarrantyType")), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
    }], (elems_3 = [MuiHelpers_createElement(FormControl, [["style", {
        width: 100 + "%",
    }], (elements_1 = [MuiHelpers_createElement(RadioGroup, toList(delay(() => append(singleton(["row", true]), delay(() => {
        let matchValue;
        return append((matchValue = current, (matchValue != null) ? singleton(["value", int32ToString(matchValue)]) : (empty())), delay(() => append(singleton(["onChange", (e) => {
            const x = e.target.value;
            let matchResult, c_2;
            if (current != null) {
                if (int32ToString(current) === x) {
                    matchResult = 0;
                    c_2 = current;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    onSelect(undefined);
                    break;
                }
                case 1: {
                    try {
                        onSelect(parse_2(x, 511, false, 32));
                    }
                    catch (matchValue_1) {
                    }
                    break;
                }
            }
        }]), delay(() => {
            let elements;
            return singleton((elements = map((chunk) => {
                let elems;
                return createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                }], (elems = map((wt) => MuiHelpers_createElement(FormControlLabel, [["control", MuiHelpers_createElement(Radio, [["color", "primary"]])], ["value", int32ToString(Tickets_WarrantyType__get_Identifier(wt))], ["label", Tickets_toLocalizedWarrantyType(Tickets_WarrantyType__get_Identifier(wt), locale)]]), chunk), ["children", reactApi.Children.toArray(Array.from(elems))])])));
            }, splitInto(3, Tickets_WarrantyType_All())), ["children", reactApi.Children.toArray(Array.from(elements))]));
        }))));
    })))))], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {}], (elems_4 = [MuiHelpers_createElement(FormControlLabel, [["label", locale.t("Ticket.WarrantyType.Other")], ["checked", current == null], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"]])], ["onChange", (e_1) => {
        const _arg = e_1.target.checked;
        onSelect(undefined);
    }]])], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), (children = toList(delay(() => ((current == null) ? singleton(MuiHelpers_createElement(TextField, [["disabled", current != null], ["fullWidth", true], ["multiline", true], ["variant", "filled"], ["defaultValue", warrantyText], ["onChange", (e_2) => {
        onWarrantyText(e_2.target.value);
    }]])) : empty()))), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function warrantyReservation(locale, current, reservationText, onSelect, onReservationText) {
    let elems_2, elems_1;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_2 = [sectionHeader(locale.t("Ticket.WarrantyReservation")), createElement("p", {
        style: {
            fontSize: 0.85 + "rem",
        },
        children: locale.t("Ticket.WarrantyReservationDesc"),
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 10 + "px ",
    }], (elems_1 = [createElement("span", {
        style: {
            fontSize: 0.85 + "rem",
        },
        children: locale.t("Ticket.WarrantyHasReservation"),
    }), MuiHelpers_createElement(RadioGroup, toList(delay(() => append(singleton(["row", true]), delay(() => {
        let matchValue;
        return append((matchValue = current, (matchValue != null) ? singleton(["value", toString(matchValue)]) : (empty())), delay(() => append(singleton(["onChange", (e) => {
            const x = e.target.value;
            switch (x) {
                case "true": {
                    onSelect(true);
                    break;
                }
                case "false": {
                    onSelect(false);
                    break;
                }
                default:
                    undefined;
            }
        }]), delay(() => {
            let elements;
            return singleton((elements = [MuiHelpers_createElement(FormControlLabel, [["control", MuiHelpers_createElement(Radio, [["color", "primary"]])], ["value", toString(true)], ["label", locale.t("Yes")]]), MuiHelpers_createElement(FormControlLabel, [["control", MuiHelpers_createElement(Radio, [["color", "primary"]])], ["value", toString(false)], ["label", locale.t("No")]])], ["children", reactApi.Children.toArray(Array.from(elements))]));
        }))));
    })))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), MuiHelpers_createElement(TextField, [["fullWidth", true], ["multiline", true], ["variant", "filled"], ["disabled", (current != null) ? (!current) : true], ["label", locale.t("Ticket.WarrantyReservationReason")], ["defaultValue", reservationText], ["onChange", (e_1) => {
        onReservationText(e_1.target.value);
    }]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function warrantyParts(locale, current, onAddForm, onRemove) {
    let elems_7, elements_6, children_1, children, children_6, children_5, elements_3, child, props_7;
    const th$0027 = (x) => MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "head"], ["children", x]]);
    const td$0027 = (x_1) => MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["children", x_1]]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_7 = [sectionHeader(locale.t("Ticket.WarrantyPart.FaultyParts")), MuiHelpers_createElement(Table, [["size", "small"], (elements_6 = [(children_1 = singleton_1((children = ofArray([th$0027(locale.t("Ticket.WarrantyPart.PartNo")), th$0027(locale.t("Ticket.WarrantyPart.Num")), th$0027(locale.t("Ticket.WarrantyPart.Desc")), th$0027("")]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_6 = ofArray([map((c) => {
        let props_3;
        const children_3 = ofArray([td$0027(c.PartNo), td$0027(int32ToString(c.Num)), td$0027(c.Desc), MuiHelpers_createElement(TableCell, [["variant", "body"], ["size", "small"], ["children", MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_3 = {}, react.createElement(Delete, props_3))], ["onClick", (_arg) => {
            onRemove(c.Id);
        }]])]])]);
        return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_3))]]);
    }, current), (children_5 = ofArray([MuiHelpers_createElement(TableCell, [["variant", "body"], ["size", "small"], (elements_3 = [(child = MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_7 = {}, react.createElement(Add, props_7))], ["onClick", (_arg_1) => {
        onAddForm();
    }]]), wrapTooltip(locale.t("Add"), child))], ["children", reactApi.Children.toArray(Array.from(elements_3))])]), td$0027(""), td$0027(""), td$0027("")]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_5))]]))]), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_6))]]))], ["children", reactApi.Children.toArray(Array.from(elements_6))])]), createElement("p", {
        style: {
            fontSize: 0.85 + "rem",
        },
        children: locale.t("Ticket.WarrantyPart.BillingDesc"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

export function Table_th$0027(title) {
    return MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", title]]);
}

export function Table_td$0027(title) {
    return MuiHelpers_createElement(TableCell, [["title", title], ["className", join(" ", ["text-overflow"])], ["sx", {
        maxWidth: 20 + "ch",
    }], ["variant", "body"], ["children", title]]);
}

/**
 * Different text for prop title popup and the cell text
 */
export function Table_td$0027$0027(title, text) {
    return MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["style", {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: 20 + "ch",
    }], ["title", title], ["children", text]]);
}

function Table_VismaNumberStatus(table_VismaNumberStatusInputProps) {
    let props_3, props_1;
    const vismaNumber = table_VismaNumberStatusInputProps.vismaNumber;
    const customerGroups = table_VismaNumberStatusInputProps.customerGroups;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(undefined);
    const statusResOpt = patternInput[0];
    const dependencies = [vismaNumber];
    reactApi.useEffect(() => {
        let properties_2;
        const url = API_Orders_Order(vismaNumber);
        let pr_3;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(Order_$reflection(), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Order_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_3 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_3.then((arg_2) => {
            const pr_2 = mapFetchError((statusCode) => {
                switch (statusCode) {
                    case 404:
                        return "Wrong url";
                    case 410:
                        return `Order ${vismaNumber} does not exist in Kundeweb database`;
                    default:
                        return undefined;
                }
            }, arg_2);
            pr_2.then((arg_1) => {
                patternInput[1](arg_1);
            });
        });
    }, dependencies);
    if (statusResOpt != null) {
        const res_1 = statusResOpt;
        if (res_1.tag === 0) {
            const order = res_1.fields[0];
            if (!customerGroups.some((group) => defaultArg(map_1((dep) => (dep.Id === order.Company.Id), group.Company), false))) {
                console.debug("Ticket has groups:", customerGroups);
                return wrapTooltip("Ticket har ordre fra en annen avdeling", (props_3 = {}, react.createElement(PriorityHigh, props_3)));
            }
            else {
                return createElement("span", {
                    children: [Orders_OrderStatus__ToString_12C6553D(order.Status, ctx.Language)],
                });
            }
        }
        else {
            return wrapTooltip(res_1.fields[0], (props_1 = {}, react.createElement(PriorityHigh, props_1)));
        }
    }
    else {
        return loadingIndicatorSmall();
    }
}

export function Table_tdOrderStatus(lang, groups, freeTextNum, orderOpt) {
    let elements, elems;
    return MuiHelpers_createElement(TableCell, [["variant", "body"], ["align", "left"], (elements = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    }], (elems = toList(delay(() => {
        let props_3, props_1;
        if (orderOpt != null) {
            const order = orderOpt;
            return !isNullOrWhiteSpace(freeTextNum) ? ((int32ToString(order.Number) !== freeTextNum) ? singleton(wrapTooltip("Ordren og fritekstfeltet samsvarer ikke. Oppdater ordren til ticketen", (props_3 = {
                color: "error",
            }, react.createElement(Warning, props_3)))) : singleton(`${Orders_OrderStatus__ToString_12C6553D(order.Status, lang)}`)) : singleton(`${Orders_OrderStatus__ToString_12C6553D(order.Status, lang)}`);
        }
        else {
            return !isNullOrWhiteSpace(freeTextNum) ? append(singleton(wrapTooltip("Kun fritekstkobling mot ordre", (props_1 = {}, react.createElement(Warning, props_1)))), delay(() => singleton(createElement(Table_VismaNumberStatus, {
                customerGroups: groups,
                vismaNumber: parse_2(freeTextNum, 511, false, 32),
            })))) : singleton("-");
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

/**
 * Component for handling the contacted by ticket input field
 */
export function TicketContactName(ticketContactNameInputProps) {
    let elems_1;
    const onToggleSearch = ticketContactNameInputProps.onToggleSearch;
    const showSearch = ticketContactNameInputProps.showSearch;
    const onChange = ticketContactNameInputProps.onChange;
    const canEdit = ticketContactNameInputProps.canEdit;
    const name$0027 = ticketContactNameInputProps["name\'"];
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(name$0027);
    const patternInput_1 = reactApi.useState(true);
    const setValidName = patternInput_1[1];
    const timer = reactApi.useRef(0);
    const children_1 = ofArray([thHeader(ctx.Locale.t("Ticket.ContactedBy")), tdHeader([createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 5 + "px ",
        maxWidth: 80 + "ch",
    }], (elems_1 = toList(delay(() => append(singleton(MuiHelpers_createElement(TextField, [["size", "small"], ["fullWidth", true], ["defaultValue", patternInput[0]], ["error", !patternInput_1[0]], ["onChange", (e) => {
        const x = e.target.value;
        patternInput[1](x);
        debounce_1(500, timer, () => {
            if (x.trim().length < 255) {
                setValidName(true);
                onChange(x.trim());
            }
            else {
                setValidName(false);
            }
        });
    }]])), delay(() => {
        let child, elems, props_2;
        return (canEdit && showSearch) ? singleton((child = createElement("div", createObj(ofArray([["onClick", (_arg) => {
            onToggleSearch();
        }], ["style", {
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
        }], (elems = [(props_2 = {}, react.createElement(Search, props_2))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), wrapTooltip(ctx.Locale.t("Edit"), child))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))])]);
    return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_1))]]);
}

/**
 * Component used to handle the ticket contact email field
 */
export function TicketContactEmail(ticketContactEmailInputProps) {
    let elems;
    const onChange = ticketContactEmailInputProps.onChange;
    const canEdit = ticketContactEmailInputProps.canEdit;
    const email$0027 = ticketContactEmailInputProps["email\'"];
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(email$0027);
    const patternInput_1 = reactApi.useState(true);
    const setValidEmail = patternInput_1[1];
    const timer = reactApi.useRef(0);
    const children = ofArray([thHeader(ctx.Locale.t("Ticket.EmailContactedBy")), tdHeader([createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
        maxWidth: 80 + "ch",
    }], (elems = [MuiHelpers_createElement(TextField, [["size", "small"], ["fullWidth", true], ["disabled", !canEdit], ["defaultValue", patternInput[0]], ["error", !patternInput_1[0]], ["onChange", (e) => {
        const x = e.target.value;
        patternInput[1](x);
        debounce_1(500, timer, () => {
            if (x.trim().length < 255) {
                setValidEmail(true);
                onChange(x.trim());
            }
            else {
                setValidEmail(false);
            }
        });
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))])]);
    return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]);
}

/**
 * Component used to handle the ticket contact phone and phone country code fields
 */
export function TicketContactPhone(ticketContactPhoneInputProps) {
    let elems;
    const onChange = ticketContactPhoneInputProps.onChange;
    const canEdit = ticketContactPhoneInputProps.canEdit;
    const phone$0027 = ticketContactPhoneInputProps["phone\'"];
    const phoneCC$0027 = ticketContactPhoneInputProps["phoneCC\'"];
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(phoneCC$0027);
    const phoneCC = patternInput[0];
    const patternInput_1 = reactApi.useState(phone$0027);
    const phone = patternInput_1[0];
    const patternInput_2 = reactApi.useState(true);
    const setValidCC = patternInput_2[1];
    const patternInput_3 = reactApi.useState(true);
    const setValidPhone = patternInput_3[1];
    const timer = reactApi.useRef(0);
    const debounce = (f) => {
        debounce_1(500, timer, f);
    };
    const children = ofArray([thHeader(ctx.Locale.t("Ticket.PhoneContactedBy")), tdHeader([createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
        maxWidth: 80 + "ch",
    }], (elems = [MuiHelpers_createElement(TextField, [["style", {
        width: 10 + "ch",
    }], ["size", "small"], ["defaultValue", phoneCC], ["error", !patternInput_2[0]], ["disabled", !canEdit], ["InputProps", {
        startAdornment: MuiHelpers_createElement(InputAdornment, [["style", {
            margin: ((0 + "px ") + 5) + "px",
        }], ["position", "start"], ["children", "+"]]),
    }], ["onChange", (e) => {
        const x = e.target.value;
        patternInput[1](x);
        debounce(() => {
            if (x.trim().length < 6) {
                setValidCC(true);
                onChange([x.trim(), phone]);
            }
            else {
                setValidCC(false);
            }
        });
    }]]), MuiHelpers_createElement(TextField, [["size", "small"], ["fullWidth", true], ["disabled", !canEdit], ["defaultValue", phone], ["error", !patternInput_3[0]], ["onChange", (e_1) => {
        const newPhoneNr = e_1.target.value;
        patternInput_1[1](newPhoneNr);
        debounce(() => {
            if (newPhoneNr.trim().length < 15) {
                setValidPhone(true);
                onChange([phoneCC, newPhoneNr.trim()]);
            }
            else {
                setValidPhone(false);
            }
        });
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))])]);
    return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]);
}

/**
 * Component for the short description input section in tickets. Uses timer to avoid calling dispatch on every character change.
 */
export function TicketShortDesc(ticketShortDescInputProps) {
    let elems;
    const onChange = ticketShortDescInputProps.onChange;
    const defaultValue = ticketShortDescInputProps.defaultValue;
    const headerTitle = ticketShortDescInputProps.headerTitle;
    const patternInput = reactApi.useState(defaultValue);
    const localText = patternInput[0];
    const timer = reactApi.useRef(0);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems = [sectionHeader(headerTitle), MuiHelpers_createElement(TextField, [["fullWidth", true], ["required", true], ["variant", "filled"], ["defaultValue", defaultValue], ["label", `${localText.length}/${120}`], ["error", localText.length > 120], ["onChange", (e) => {
        const x = e.target.value;
        patternInput[1](x);
        debounce_1(500, timer, () => {
            onChange(x);
        });
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

/**
 * Component for the description input section in tickets. Uses timer to avoid calling dispatch on every character change.
 */
export function TicketDescription(ticketDescriptionInputProps) {
    let elems;
    const onChange = ticketDescriptionInputProps.onChange;
    const defaultValue = ticketDescriptionInputProps.defaultValue;
    const ticketType = ticketDescriptionInputProps.ticketType;
    const ctx = reactApi.useContext(ctx_1);
    const timer = reactApi.useRef(0);
    const headerTitle = (ticketType === Tickets_TicketType__get_Id(new Tickets_TicketType(5, []))) ? ctx.Locale.t("Ticket.NonconformityDesc") : ctx.Locale.t("Ticket.Desc");
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems = [sectionHeader(headerTitle), MuiHelpers_createElement(TextField, [["fullWidth", true], ["required", true], ["variant", "filled"], ["multiline", true], ["defaultValue", defaultValue], ["onChange", (e) => {
        const x = e.target.value;
        debounce_1(500, timer, () => {
            onChange(x);
        });
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

/**
 * Component for the description2 input section in tickets. Used with warranty and nonconformity tickets. Uses timer to avoid calling dispatch on every character change.
 */
export function TicketDescription2(ticketDescription2InputProps) {
    let elems;
    const onChange = ticketDescription2InputProps.onChange;
    const defaultValue = ticketDescription2InputProps.defaultValue;
    const ticketType = ticketDescription2InputProps.ticketType;
    const ctx = reactApi.useContext(ctx_1);
    const timer = reactApi.useRef(0);
    const headerTitle = (ticketType === Tickets_TicketType__get_Id(new Tickets_TicketType(5, []))) ? ctx.Locale.t("Ticket.SuggestionsForImprovement") : ctx.Locale.t("Ticket.FaultDescription");
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems = [sectionHeader(headerTitle), MuiHelpers_createElement(TextField, [["fullWidth", true], ["required", true], ["variant", "filled"], ["multiline", true], ["defaultValue", defaultValue], ["onChange", (e) => {
        const x = e.target.value;
        debounce_1(500, timer, () => {
            onChange(x);
        });
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function WarrantyPartForm(warrantyPartFormInputProps) {
    let elements_2, children, elems, children_1;
    const onClose = warrantyPartFormInputProps.onClose;
    const defaultId = warrantyPartFormInputProps.defaultId;
    const ctx = reactApi.useContext(ctx_1);
    const f = new Tickets_WarrantyPart(defaultId - 1, "", 0, "");
    const patternInput = reactApi.useState(f);
    const updatePartForm = patternInput[1];
    const partForm = patternInput[0];
    const patternInput_1 = reactApi.useState(true);
    const validNum = patternInput_1[0];
    const setValidNum = patternInput_1[1];
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_1, v) => {
        onClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("Ticket.WarrantyPart.FaultyParts")]]), (children = singleton_1(createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px ",
    }], (elems = [MuiHelpers_createElement(TextField, [["variant", "outlined"], ["defaultValue", partForm.PartNo], ["label", ctx.Locale.t("Ticket.WarrantyPart.PartNo")], ["onChange", (e) => {
        updatePartForm(new Tickets_WarrantyPart(partForm.Id, e.target.value, partForm.Num, partForm.Desc));
    }]]), MuiHelpers_createElement(TextField, [["variant", "outlined"], ["defaultValue", partForm.Num], ["label", ctx.Locale.t("Ticket.WarrantyPart.Num")], ["error", !validNum], ["onChange", (e_1) => {
        const x_1 = e_1.target.value;
        try {
            const asInt = parse_2(x_1, 511, false, 32) | 0;
            if (asInt >= 0) {
                updatePartForm(new Tickets_WarrantyPart(partForm.Id, partForm.PartNo, asInt, partForm.Desc));
                setValidNum(true);
            }
            else {
                setValidNum(false);
            }
        }
        catch (matchValue) {
            setValidNum(false);
        }
    }]]), MuiHelpers_createElement(TextField, [["variant", "outlined"], ["defaultValue", partForm.Desc], ["label", ctx.Locale.t("Ticket.WarrantyPart.Desc")], ["onChange", (e_2) => {
        updatePartForm(new Tickets_WarrantyPart(partForm.Id, partForm.PartNo, partForm.Num, e_2.target.value));
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = ofArray([MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_2) => {
        onClose(undefined);
    }]]), MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["disabled", (partForm.PartNo.trim().length === 0) ? true : !validNum], ["children", ctx.Locale.t("Add")], ["onClick", (_arg_3) => {
        onClose(partForm);
    }]])]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

